import { onMounted, ref, type Ref } from 'vue'

import { useUserStore } from '@/stores/userStore'

interface UseEnsureCurrentUserUseIsInitializedRoute {
  isInitialized: Ref<boolean>
}

export const useEnsureCurrentUser =
  (): UseEnsureCurrentUserUseIsInitializedRoute => {
    const userStore = useUserStore()
    const isInitialized = ref<boolean>(false)

    onMounted(async (): Promise<void> => {
      if (userStore.userData) {
        isInitialized.value = true
        return
      }

      try {
        await userStore.fetchCurrentUser()
      } finally {
        isInitialized.value = true
      }
    })
    return { isInitialized }
  }
